const contact = () => {
    if (!$(".contact").length) return;
}

module.exports = contact
